import React from 'react';
import { Container, Col, Row } from 'react-bootstrap';
import { Button } from '@material-ui/core';
import PropTypes from 'prop-types';
import { ThemeProvider,createTheme,makeStyles } from '@material-ui/core/styles';
import { Link, useHistory } from 'react-router-dom';
import './HeroImage.scss';
import { SESSION_STORAGE_TERM_REVIEW_OBJECT_KEY, SESSION_STORAGE_PERM_REVIEW_OBJECT_KEY } from '../../sessionStorage';
import Breadcrumb from '../Common/Breadcrumb/Breadcrumb';

const white = '#fff';
const theme = createTheme({
  overrides: {
    MuiButton: {
      contained: {
        color: 'primary',
        '&:focus': {
          outline: 'none'
        }
      },
      outlined: {
        color: white,
        border: `1px solid ${white}`,
        '&:focus': {
          border: `1px solid ${white}`,
          outline: 'none'
        }
      }
    }
  }
});

const useSecondaryButtonStyles = makeStyles(theme => ({
  button: {
    backgroundColor: theme.palette.primary.main,
    color: 'white'
  }
}));

function HeroImage(props) {

  const useStyles = makeStyles(theme => ({
    heroImage: {
      backgroundColor: '#fff',
      backgroundRepeat: 'no-repeat',
      opacity: 1
    },
  }));

  const secondaryButtonStyle = useSecondaryButtonStyles().button;
  const classes = useStyles();
  const history = useHistory();
  const onButtonClick = value => {
    if(value === 'term'){
      sessionStorage.removeItem(SESSION_STORAGE_TERM_REVIEW_OBJECT_KEY);
      history.push('/Quote/TermReview');
    }
    if(value==='perm'){
      sessionStorage.removeItem(SESSION_STORAGE_PERM_REVIEW_OBJECT_KEY);
      history.push('/Quote/PermReview');
    }
    else{
      return;
    }
  };

  return (
    <Row className="landing-hero-image justify-content-center">
      <div className={`backgroundImage ${classes.heroImage}`}>
        <Container fluid className="pl-0 hero-content">
          <Row className="d-flex align-items-center ml-4">
            <Col lg>
              <Row className="mb-3 mt-3">
                <Breadcrumb breadcrumbLinks={[{ name: 'HOME', href: '/' }, { name: 'INSURANCE TOOLS', href: '/ResourceCenter' }]}
                  currentPage='POLICY REVIEW' />
              </Row>
              <Row>
                <div className="mailTitle pt-4 pb-2">{props.title}</div>
              </Row>
              <Row>
                <div className="landingPageTitle mb-2">{props.subtitle}</div>
              </Row>
            </Col>
            <Col lg="auto" className="hero-form">
              {props.form}
            </Col>
          </Row>
          <Row className="ml-4 mb-4">
            <ThemeProvider theme={theme}>
              <React.Fragment>
                <Link to="#" className="sub-nav-link-button">
                  <Button variant="contained" onClick={() => onButtonClick('term')} className={secondaryButtonStyle}>
                    TERM REVIEW
                  </Button>
                </Link>
                <Link to="#" className="sub-nav-link-button">
                  <Button variant="contained" onClick={() => onButtonClick('perm')} className={`ml-3 ${secondaryButtonStyle}`}>
                    PERM REVIEW
                  </Button>
                </Link>
              </React.Fragment>
            </ThemeProvider>
          </Row>
        </Container>
      </div>
    </Row>
  );
}

HeroImage.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired
};

export default React.memo(HeroImage);



// WEBPACK FOOTER //
// ./src/components/PolicyReview/HeroImage.js